import { GuiLogger } from "@rtbhouse-apps/logger";
const logger = new GuiLogger();
export { logger };
//# sourceMappingURL=logger.js.map